import React from "react";
import "./Clientspage.css";
import Clients1 from "../../Assets/Images/Clients/Group 18160.webp";
import Clients2 from "../../Assets/Images/Clients/Group 18161.webp";
import Clients3 from "../../Assets/Images/Clients/Group 18401.webp";
import Clients4 from "../../Assets/Images/Clients/Group 18402.webp";
import Clients5 from "../../Assets/Images/Clients/Group 18403.webp";
import Clients6 from "../../Assets/Images/Clients/Group 18406.webp";
import Clients7 from "../../Assets/Images/Clients/Group 18407.webp";
import Clients8 from "../../Assets/Images/Clients/Group 18408.webp";
import Clients9 from "../../Assets/Images/Clients/Group 18412-1.webp";
import Clients10 from "../../Assets/Images/Clients/Group 18412.webp";
import Clients11 from "../../Assets/Images/Clients/Group 18413-1.webp";
import Clients12 from "../../Assets/Images/Clients/Group 18413.webp";
import Clients13 from "../../Assets/Images/Clients/Group 18414-1.webp";
import Clients14 from "../../Assets/Images/Clients/Group 18414.webp";
import Clients15 from "../../Assets/Images/Clients/Group 18415-1.webp";
import Clients16 from "../../Assets/Images/Clients/Group 18415.webp";
import Clients17 from "../../Assets/Images/Clients/Group 18416.webp";
import Clients18 from "../../Assets/Images/Clients/Group 18417.webp";
import Clients19 from "../../Assets/Images/Clients/Group 18418.webp";
import Clients20 from "../../Assets/Images/Clients/Group 18419.webp";
import Clients21 from "../../Assets/Images/Clients/Group 18420.webp";
import Clients22 from "../../Assets/Images/Clients/Group 18421.webp";
import Clients23 from "../../Assets/Images/Clients/Group 18425.webp";
import Clients24 from "../../Assets/Images/Clients/Group 18426.webp";
import Clients25 from "../../Assets/Images/Clients/Group 18440.webp";
import Clients26 from "../../Assets/Images/Clients/Group 18441.webp";
import Clients27 from "../../Assets/Images/Clients/Group 18442.webp";
import Clients28 from "../../Assets/Images/Clients/Group 18443.webp";
import Clients29 from "../../Assets/Images/Clients/Group 18445.webp";
import Clients30 from "../../Assets/Images/Clients/Group 18450.webp";

import Clients31 from "../../Assets/Images/Clients/Group 1272628229.webp";
import Clients32 from "../../Assets/Images/Clients/Group 1272628230.webp";
import Clients33 from "../../Assets/Images/Clients/Group 1272628233.webp";
import Clients34 from "../../Assets/Images/Clients/Group 1272628235.webp";
import Clients35 from "../../Assets/Images/Clients/Group 1272628236.webp";
import Clients36 from "../../Assets/Images/Clients/Group 1272628239.webp";
import Clients37 from "../../Assets/Images/Clients/Group 1272628241.webp";
import Clients38 from "../../Assets/Images/Clients/Group 1272628244.webp";
import Clients39 from "../../Assets/Images/Clients/Group 1272628247.webp";
import Clients40 from "../../Assets/Images/Clients/Group 1272628248.webp";
import Clients41 from "../../Assets/Images/Clients/Group 1272628252.webp";
import Clients42 from "../../Assets/Images/Clients/Group 1272628255.webp";
import Clients43 from "../../Assets/Images/Clients/Group 1272628256.webp";
import Clients44 from "../../Assets/Images/Clients/Group 1272628257.webp";
import Clients45 from "../../Assets/Images/Clients/Group 1272628258.webp";
import Clients46 from "../../Assets/Images/Clients/Group 1272628259.webp";
import Clients47 from "../../Assets/Images/Clients/Group 1272628260.webp";
import Clients48 from "../../Assets/Images/Clients/Group 1272628261.webp";
import Clients49 from "../../Assets/Images/Clients/Group 1272628263.webp";
import Clients50 from "../../Assets/Images/Clients/Group 1272628266.webp";
import Clients51 from "../../Assets/Images/Clients/Group 1272628267.webp";
import Clients52 from "../../Assets/Images/Clients/Group 1272628268.webp";
import Clients53 from "../../Assets/Images/Clients/Group 1272628270.webp";
import Clients54 from "../../Assets/Images/Clients/Group 1272628272.webp";
import Clients55 from "../../Assets/Images/Clients/Group 1272628274.webp";
import Clients56 from "../../Assets/Images/Clients/Group 1272628276.webp";
import Clients57 from "../../Assets/Images/Clients/Group 1272628278.webp";
import Clients58 from "../../Assets/Images/Clients/Group 1272628280.webp";
import Clients59 from "../../Assets/Images/Clients/Group 1272628282.webp";
import Clients60 from "../../Assets/Images/Clients/Group 1272628284.webp";
import Clients61 from "../../Assets/Images/Clients/Group 1272628286.webp";
import Clients62 from "../../Assets/Images/Clients/Group 1272628288.webp";
import Clients63 from "../../Assets/Images/Clients/Group 1272628290.webp";
import Clients64 from "../../Assets/Images/Clients/Group 1272628293.webp";
import Clients65 from "../../Assets/Images/Clients/Group 1272628344.webp";
import Clients66 from "../../Assets/Images/Clients/Group 18477.webp";
import Clients67 from "../../Assets/Images/Clients/Vicefy.webp";
import Clients68 from "../../Assets/Images/Clients/TrudianceBeauty.webp";
import Clients69 from "../../Assets/Images/Clients/SouvenirLogo.webp";
import Clients70 from "../../Assets/Images/Clients/LuVialz.webp";
import Clients71 from "../../Assets/Images/Clients/Reliive.webp";

import Client72 from "../../Assets/Images/Clients/accurion.webp";
import Clients73 from "../../Assets/Images/Clients/alliswell.webp";
import Clients74 from "../../Assets/Images/Clients/beraw.webp";
import Clients75 from "../../Assets/Images/Clients/businessstandard.webp";
import Clients76 from "../../Assets/Images/Clients/cyringe.webp";
import Clients77 from "../../Assets/Images/Clients/foram.webp";
import Clients78 from "../../Assets/Images/Clients/tiqet.webp";
import Clients79 from "../../Assets/Images/Clients/goldstandardsports.webp";
import Clients80 from "../../Assets/Images/Clients/jphome.webp";
import Clients81 from "../../Assets/Images/Clients/makraw.webp";
import Clients82 from "../../Assets/Images/Clients/mindnmuscle.webp";
import Clients83 from "../../Assets/Images/Clients/newtons.webp";
import Clients84 from "../../Assets/Images/Clients/prost.webp";
import Clients85 from "../../Assets/Images/Clients/saaro.webp";


function Clientslistpage() {
  return (
    <div className="Clientslistpage">
      <div className="clientsimagesection">
        <div className="clientsimagesection-imgBox">
          <img src={Clients17} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients18} alt="" />
        </div>

        <div className="clientsimagesection-imgBox">
          <img src={Clients14} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients10} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients2} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients3} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients1} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients4} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients5} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients6} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients7} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients8} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients9} alt="" />
        </div>

        <div className="clientsimagesection-imgBox">
          <img src={Clients11} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients12} alt="" />
        </div>

        <div className="clientsimagesection-imgBox">
          <img src={Clients13} alt="" />
        </div>

        <div className="clientsimagesection-imgBox">
          <img src={Clients15} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients16} alt="" />
        </div>

        <div className="clientsimagesection-imgBox">
          <img src={Clients19} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients20} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients21} alt="" />
        </div>
        {/* <div className='clientsimagesection-imgBox' >
    <img src={Clients22} alt=""  />
    </div> */}
        <div className="clientsimagesection-imgBox">
          <img src={Clients23} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients24} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients25} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients26} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients27} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients28} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients29} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients30} alt="" />
        </div>
        {/* <div className='clientsimagesection-imgBox' >
    <img src={Clients31} alt=""  />
    </div>
    <div className='clientsimagesection-imgBox' >
    <img src={Clients32} alt=""  />
    </div> */}
        <div className="clientsimagesection-imgBox">
          <img src={Clients33} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients34} alt="" />
        </div>
        {/* <div className='clientsimagesection-imgBox' >
    <img src={Clients35} alt=""  />
    </div> */}
        <div className="clientsimagesection-imgBox">
          <img src={Clients36} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients37} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients38} alt="" />
        </div>
        {/* <div className='clientsimagesection-imgBox' >
    <img src={Clients39} alt=""  />
    </div> */}
        {/* <div className='clientsimagesection-imgBox' >
    <img src={Clients40} alt=""  />
    </div> */}
        <div className="clientsimagesection-imgBox">
          <img src={Clients41} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients42} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients43} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients44} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients45} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients46} alt="" />
        </div>
        {/* <div className='clientsimagesection-imgBox' >
    <img src={Clients47} alt=""  />
    </div> */}
        <div className="clientsimagesection-imgBox">
          <img src={Clients48} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients49} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients50} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients51} alt="" />
        </div>
        {/* <div className="clientsimagesection-imgBox">
          <img src={Clients52} alt="" />
        </div> */}
        <div className="clientsimagesection-imgBox">
          <img src={Clients53} alt="" />
        </div>
        {/* <div className="clientsimagesection-imgBox">
          <img src={Clients54} alt="" />
        </div> */}
        <div className="clientsimagesection-imgBox">
          <img src={Clients55} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients56} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients57} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients58} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients59} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients60} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients61} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients62} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients63} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients64} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients65} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients66} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients67} alt="" />
        </div>
        <div
          className="clientsimagesection-imgBox"
          style={{ alignSelf: "center" }}
        >
          <img src={Clients68} alt="" />
        </div>
        <div
          className="clientsimagesection-imgBox"
          style={{ alignSelf: "center" }}
        >
          <img src={Clients69} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients70} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Clients71} alt="" />
        </div>
        <div className="clientsimagesection-imgBox">
          <img src={Client72} alt="" />
        </div><div className="clientsimagesection-imgBox">
          <img src={Clients73} alt="" />
        </div><div className="clientsimagesection-imgBox">
          <img src={Clients74} alt="" />
        </div><div className="clientsimagesection-imgBox">
          <img src={Clients75} alt="" />
        </div><div className="clientsimagesection-imgBox">
          <img src={Clients76} alt="" />
        </div><div className="clientsimagesection-imgBox">
          <img src={Clients77} alt="" />
        </div><div className="clientsimagesection-imgBox">
          <img src={Clients78} alt="" />
        </div><div className="clientsimagesection-imgBox">
          <img src={Clients79} alt="" />
        </div><div className="clientsimagesection-imgBox">
          <img src={Clients80} alt="" />
        </div><div className="clientsimagesection-imgBox">
          <img src={Clients81} alt="" />
        </div><div className="clientsimagesection-imgBox">
          <img src={Clients82} alt="" />
        </div><div className="clientsimagesection-imgBox">
          <img src={Clients83} alt="" />
        </div><div className="clientsimagesection-imgBox">
          <img src={Clients84} alt="" />
        </div><div className="clientsimagesection-imgBox">
          <img src={Clients85} alt="" />
        </div>
      </div>
    </div>
  );
}

export default Clientslistpage;
